module.exports = __webpack_public_path__ + "static/Anggita-f6fc462913e66529e48d976a0e6e6334.jpg";